import { AgentDetails } from "@/modules/agents/AgentDetails";

export default function AgentDetailsPage() {
  return <AgentDetails />;
}
